import { EventLogProvider } from '@axo/shared/data-access/event-log';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { ReactNode, useContext } from 'react';
import { ApplicationContext } from '../../store/context';

export function EventLogWrapper({ children }: { children: ReactNode }) {
  const { state: dataAccessState } = useContext(DataAccessContext);
  const { state } = useContext(ApplicationContext);
  const api = useAPI();

  return (
    <EventLogProvider
      token={dataAccessState.user.token}
      apiURL={api.url.service}
      marketCountry={state.marketCountry ?? ''}
      source={'ACE'}
    >
      {children}
    </EventLogProvider>
  );
}
